import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
var e = /*#__PURE__*/function () {
  function e(_e) {
    _classCallCheck(this, e);

    this.readFile = _e;
  }

  _createClass(e, [{
    key: "resolveIncludes",
    value: function resolveIncludes(_e2) {
      return this.resolve(_e2);
    }
  }, {
    key: "resolve",
    value: function resolve(_e3) {
      var _this = this;

      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Map();
      if (t.has(_e3)) return t.get(_e3);
      var r = this.read(_e3);
      if (!r) throw new Error("cannot find shader file ".concat(_e3));
      var s = /^[^\S\n]*#include\s+<(\S+)>[^\S\n]?/gm;
      var n = s.exec(r);
      var l = [];

      for (; null != n;) {
        l.push({
          path: n[1],
          start: n.index,
          length: n[0].length
        }), n = s.exec(r);
      }

      var a = 0,
          h = "";
      return l.forEach(function (_e4) {
        h += r.slice(a, _e4.start), h += t.has(_e4.path) ? "" : _this.resolve(_e4.path, t), a = _e4.start + _e4.length;
      }), h += r.slice(a), t.set(_e3, h), h;
    }
  }, {
    key: "read",
    value: function read(_e5) {
      return this.readFile(_e5);
    }
  }]);

  return e;
}();

export { e as default };